
import { z } from "zod";

export const formSchema = z.object({
  firstName: z.string().min(2, { message: "Le prénom doit contenir au moins 2 caractères" }),
  lastName: z.string().min(2, { message: "Le nom doit contenir au moins 2 caractères" }),
  email: z.string().email({ message: "Veuillez entrer une adresse email valide" }),
  address: z.string().optional(),
  city: z.string().optional(),
  postalCode: z.string().optional(),
  membershipType: z.enum(["active", "benefactor", "donor"]),
  additionalDonation: z.number().min(0).default(0),
  acceptTerms: z.boolean().refine(val => val === true, {
    message: "Vous devez accepter les conditions pour adhérer"
  }),
  acceptNewsletter: z.boolean().default(false),
  declareFrenchCitizen: z.boolean().refine(val => val === true, {
    message: "Vous devez déclarer être citoyen français pour adhérer"
  }),
  includeEntryFee: z.boolean().default(false)
}).refine(
  (data) => {
    // Only validate donation amount for donor type
    return data.membershipType !== "donor" || data.additionalDonation > 0;
  },
  {
    message: "Le montant du don doit être supérieur à 0€ pour les donateurs",
    path: ["additionalDonation"]
  }
);

export type FormValues = z.infer<typeof formSchema>;
